import styled from 'styled-components';
import * as Comp from './components/StatusBadge';

export const StatusBadge = styled(Comp.StatusBadge)``;
export interface StatusBadgeProps extends Comp.StatusBadgeProps {}
